import { USER_ROLES } from "../constants/user";

export const getSubscriptionFeatures = (plans?: { role: string; features?: string[] }[]) => {
  return (plans ?? []).flatMap(({ role, features }) =>
    (features ?? [])
      .filter((feature: string) => !feature.toLowerCase().includes("user personas"))
      .map((feature: string) => ({
        feature,
        [USER_ROLES.FREE]: false,
        [USER_ROLES.MINIMAL]: role === USER_ROLES.MINIMAL,
        [USER_ROLES.BASIC]: role === USER_ROLES.MINIMAL || role === USER_ROLES.BASIC,
        [USER_ROLES.PREMIUM]: role === USER_ROLES.MINIMAL || role === USER_ROLES.BASIC || role === USER_ROLES.PREMIUM,
      })),
  );
};
